import { useCallback } from 'react';

import { formatPrice } from '../../components/helper/formatPrice';
import { useGlobalStore } from '../../store/store';

export const useFormatCurrency = () => {
  const { currency } = useGlobalStore();

  return useCallback(
    (value: number) => {
      return formatPrice({
        amount: value,
        currency,
      });
    },
    [currency],
  );
};
